export enum DependentType {
    SPOUSE = "SPOUSE",
    CHILD = "CHILD"
}